// client-web-appsuite/src/constants/action.js

let ACTION = {

    DESCRIBE_IDEA: {
        id: 'describe_idea', 
        label: 'describe idea' 
    },
    DESCRIBE_EDIT: {
        id: 'describe_edit',
        label: 'describe edit'
    },
    DESCRIBE_SKETCH: {
        id: 'describe_sketch',
        label: 'describe sketch'
    },
    DESCRIBE_TEXTURE: {
        id: 'describe_texture',
        label: 'describe texture'
    },

    EDIT_DESCRIPTION: {
        id: 'edit_description',
        label: 'edit description'
    },
    EDIT_SKETCH: { 
        id: 'edit_sketch', 
        label: 'edit sketch' 
    },

    GENERATE_PREVIEWS: { 
        id: 'generate_previews', 
        label: 'generate previews' 
    },
    GENERATE_MODEL: {
        id: 'generate_model',
        label: 'generate model'
    },
    GENERATE_TEXTURE: {
        id: 'generate_texture',
        label: 'generate texture'
    },

    HIGHLIGHT_EDIT: {
        id: 'highlight_edit',
        label: 'edit image'
    },

    MAKE_SKETCH: { 
        id: 'make_sketch', 
        label: 'make sketch' 
    },

    MAKE_WATERTIGHT: {
        id: 'make_watertight',
        label: 'make watertight'
    },

    REFINE_MODEL: { 
        id: 'optimize_model', 
        label: 'refine model' 
    },

    VIEW_MODEL: {
        id: 'view_model', 
        label: 'view model'
    },

    TRY_AGAIN: {
        id: 'try_again', 
        label: 'try again'
    }
}

ACTION = Object.freeze(ACTION)

export default ACTION